import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  padding: ${({ theme }) => theme.spacing(1.5)};

  border-radius: ${({ theme }) => theme.spacing(2)};
  background: transparent;
  transition: background-color 200ms;
  cursor: pointer;
`;

export const Header = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const CheckboxContainer = styled.span<{ $isFaded?: boolean }>`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 2rem;
  height: 2rem;
  min-width: 2rem;
  min-height: 2rem;

  line-height: 62.5%;
  font-size: 2rem;
  color: ${({ theme }) => theme.palette.grey['400']};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      width: 3.2rem;
      height: 3.2rem;
      min-width: 3.2rem;
      min-height: 3.2rem;
    `};

  ${({ $isFaded }) =>
    $isFaded &&
    css`
      opacity: 0.3;
    `};
`;

export const HeaderContent = styled.div<{ $isFaded?: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.75)};
  min-width: 0;

  ${({ $isFaded }) =>
    $isFaded &&
    css`
      opacity: 0.5;
    `}

  ${({ theme }) =>
    theme.isMobile &&
    css`
      padding-top: ${({ theme }) => theme.spacing(1.5)};
      pointer-events: none;
    `};
`;

export const TitleContainer = styled.span<{ $isFaded: boolean }>`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  flex: 1;

  ${({ $isFaded, theme }) =>
    $isFaded &&
    css`
      color: ${theme.palette.text.secondary};
    `};
`;

export const CollapsedContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Body = styled.div`
  ${({ theme }) => typographyToCss(theme.typography.overline)};
  padding-left: ${({ theme }) => theme.spacing(6.5)};
`;

export const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  flex-wrap: wrap;

  margin-top: ${({ theme }) => theme.spacing(0.5)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  padding-left: ${({ theme }) => theme.spacing(6.5)};
`;
